// src/redux/stafftaskSlice.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  get_stafftask,
  add_stafftask,
  update_stafftask,
  delete_stafftask,
} from '../Service/ApiServices.js';
import { toast } from 'react-toastify';

const initialState = {
  stafftask: [],
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
     title:"",
    description:"",
    user:"",
    role:"",
    priority:"",
    due_date:"",

  },
};



// Async Thunks for API Calls
export const fetchstafftask = createAsyncThunk(
  "stafftask/fetchstafftask",
  async ({ page, page_size,search,school_id,formdata, token, signal }, { rejectWithValue }) => {

    try {
      const response = await get_stafftask(page, page_size,search,school_id,formdata,token, signal);

        
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



export const createstafftask = createAsyncThunk(
  "stafftask/createstafftask",
  async ({ data,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_stafftask(data,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updatestafftask = createAsyncThunk(
  "stafftask/updatestafftask",
  async ({ data, token,school_id, signal }, { rejectWithValue }) => {
    try {
      const response = await update_stafftask(data, token,school_id, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deletestafftask = createAsyncThunk(
  "stafftask/deletestafftask",
  async ({ ids, token,school_id, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_stafftask({ ids }, token,school_id, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// stafftask Slice
const stafftaskSlice = createSlice({
  name: 'stafftasks',
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(reduxState, action) {
      reduxState.formData = { ...action.payload };
    },
    resetFormData(state) {
      state.formData = {
           title:"",
    description:"",
    user:"",
    role:"",
    priority:"",
    due_date:"",
      };
    },
    setstafftask(state, action) {
      state.stafftask = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
         // Fetch stafftask
       .addCase(fetchstafftask.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchstafftask.fulfilled, (state, action) => {
        state.loading = false;
        state.stafftask = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchstafftask.rejected, (state, action) => {
        state.loading = false;
        state.stafftask = [];
        state.error = action.payload;
      })

      // Add stafftask
      .addCase(createstafftask.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createstafftask.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createstafftask.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage);  
        state.IsEditing = false;
      })
      // Update stafftask
      .addCase(updatestafftask.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updatestafftask.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updatestafftask.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        state.IsEditing = false;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage); 
      })
      // Delete stafftask
      .addCase(deletestafftask.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletestafftask.fulfilled, (state, action) => {
        state.loading = false;
        console.log(action.payload);
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deletestafftask.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {   setstafftask,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setPageSize } = stafftaskSlice.actions;
export default stafftaskSlice.reducer;
